var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createUbiExpr2PageView } from '@spotify-internal/event-definitions/es5/events/createUbiExpr2PageView';
import { createUbiProd1PageTransitionNonAuth } from '@spotify-internal/event-definitions/es5/events/createUbiProd1PageTransitionNonAuth';
import { v4 as uuidv4 } from 'uuid';
import { NavigationReason, } from '@spotify-internal/ubi-types-js';
import { isNavigationByInteraction, isNavigationByReason, } from '@spotify-internal/ubi-types-js';
export var NavigationStatus;
(function (NavigationStatus) {
    NavigationStatus["NAVIGATION_IDLE"] = "navigation_idle";
    NavigationStatus["NAVIGATION_STARTED"] = "navigation_started";
    NavigationStatus["NAVIGATION_COMPLETED"] = "navigation_completed";
})(NavigationStatus || (NavigationStatus = {}));
export var PageViewLoggerKeys;
(function (PageViewLoggerKeys) {
    PageViewLoggerKeys["CURRENT_PAGE_ID"] = "CURRENT_PAGE_ID";
    PageViewLoggerKeys["CURRENT_PAGE_INSTANCE_ID"] = "CURRENT_PAGE_INSTANCE_ID";
    PageViewLoggerKeys["CURRENT_ENTITY_URI"] = "CURRENT_ENTITY_URI";
    PageViewLoggerKeys["CURRENT_NAV_ROOT"] = "CURRENT_NAV_ROOT";
    PageViewLoggerKeys["PENDING_NAV_ROOT"] = "PENDING_NAV_ROOT";
    PageViewLoggerKeys["PENDING_INTERACTION_ID"] = "PENDING_INTERACTION_ID";
    PageViewLoggerKeys["PENDING_NAV_REASON"] = "PENDING_NAV_REASON";
    PageViewLoggerKeys["NAVIGATION_STATUS"] = "NAV_STATUS";
})(PageViewLoggerKeys || (PageViewLoggerKeys = {}));
var PageViewLogger = (function () {
    function PageViewLogger(options) {
        var _this = this;
        this.onVisibilityChange = function () {
            if (_this.disableAutoBackgroundMonitoring)
                return;
            if (!document)
                return;
            var newVisibility = !document.hidden;
            _this.handleVisibilityChange(newVisibility);
        };
        this.onBlur = function () {
            _this.handleFocusChange(false);
        };
        this.onFocus = function () {
            _this.handleFocusChange(true);
        };
        this.eventSender = options.eventSender;
        this.pageInstanceIdProvider = options.pageInstanceIdProvider;
        this.pageUriProvider = options.pageUriProvider;
        this.pageIdProvider = options.pageIdProvider;
        this.flowIdProvider = options.flowIdProvider;
        this.authenticationProvider = options.authenticationProvider;
        this.disableAutoBackgroundMonitoring =
            options.disableAutoBackgroundMonitoring;
        if (!this.disableAutoBackgroundMonitoring) {
            if (typeof document !== 'undefined') {
                this.currentWindowState = {
                    focused: document.hasFocus(),
                    visible: !document.hidden
                };
            }
        }
        this.storageManager = options.storageManager;
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
    }
    PageViewLogger.prototype.getCurrentPageId = function () {
        return this.pageIdProvider.getPageId();
    };
    PageViewLogger.prototype.setCurrentPageId = function (pageId) {
        this.pageIdProvider.setPageId(pageId);
    };
    PageViewLogger.prototype.getCurrentPageInstanceId = function () {
        return this.pageInstanceIdProvider.getPageInstanceId();
    };
    PageViewLogger.prototype.setCurrentPageInstanceId = function (pageInstanceId) {
        this.pageInstanceIdProvider.setPageInstanceId(pageInstanceId);
    };
    PageViewLogger.prototype.getCurrentEntityUri = function () {
        return this.pageUriProvider.getPageUri();
    };
    PageViewLogger.prototype.setCurrentEntityUri = function (entityUri) {
        this.pageUriProvider.setPageUri(entityUri);
    };
    PageViewLogger.prototype.getCurrentNavigationalRoot = function () {
        return this.storageManager.getItem(PageViewLoggerKeys.CURRENT_NAV_ROOT);
    };
    PageViewLogger.prototype.setCurrentNavigationalRoot = function (navigationalRoot) {
        this.storageManager.setItem(PageViewLoggerKeys.CURRENT_NAV_ROOT, navigationalRoot);
    };
    PageViewLogger.prototype.getNavigationStatus = function () {
        return this.storageManager.getItem(PageViewLoggerKeys.NAVIGATION_STATUS);
    };
    PageViewLogger.prototype.setNavigationStatus = function (navigationStatus) {
        this.storageManager.setItem(PageViewLoggerKeys.NAVIGATION_STATUS, navigationStatus);
    };
    PageViewLogger.prototype.getPendingNavigationalRoot = function () {
        return this.storageManager.getItem(PageViewLoggerKeys.PENDING_NAV_ROOT);
    };
    PageViewLogger.prototype.setPendingNavigationalRoot = function (navigationalRoot) {
        this.storageManager.setItem(PageViewLoggerKeys.PENDING_NAV_ROOT, navigationalRoot);
    };
    PageViewLogger.prototype.getPendingInteractionId = function () {
        return this.storageManager.getItem(PageViewLoggerKeys.PENDING_INTERACTION_ID);
    };
    PageViewLogger.prototype.setPendingInteractionId = function (pendingInteractionId) {
        this.storageManager.setItem(PageViewLoggerKeys.PENDING_INTERACTION_ID, pendingInteractionId);
    };
    PageViewLogger.prototype.getPendingNavigationReason = function () {
        return this.storageManager.getItem(PageViewLoggerKeys.PENDING_NAV_REASON);
    };
    PageViewLogger.prototype.setPendingNavigationReason = function (pendingNavigationReason) {
        this.storageManager.setItem(PageViewLoggerKeys.PENDING_NAV_REASON, pendingNavigationReason);
    };
    PageViewLogger.prototype.resetNavStartInfo = function () {
        this.setPendingInteractionId(null);
        this.setPendingNavigationReason(null);
        this.setPendingNavigationalRoot(null);
    };
    PageViewLogger.prototype.populateNavigationReason = function () {
        var pendingInteractionId = this.getPendingInteractionId();
        if (pendingInteractionId) {
            var navigationReason = "user_interaction(".concat(pendingInteractionId, ")");
            this.setPendingInteractionId(null);
            return navigationReason;
        }
        return this.getPendingNavigationReason();
    };
    PageViewLogger.prototype.generatePageInstanceId = function () {
        var uuid = uuidv4();
        return uuid;
    };
    PageViewLogger.prototype.setCurrent = function (pageId, pageInstanceId, entityUri, navigationalRoot) {
        this.setCurrentPageId(pageId);
        this.setCurrentPageInstanceId(pageInstanceId);
        this.setCurrentEntityUri(entityUri);
        this.setCurrentNavigationalRoot(navigationalRoot);
    };
    PageViewLogger.prototype.isForeground = function (state) {
        return state.focused && state.visible;
    };
    PageViewLogger.prototype.handleFocusChange = function (focused) {
        if (!this.currentWindowState)
            return;
        this.handleFocusStateChange(__assign(__assign({}, this.currentWindowState), { focused: focused }));
    };
    PageViewLogger.prototype.handleVisibilityChange = function (visible) {
        if (!this.currentWindowState)
            return;
        this.handleFocusStateChange(__assign(__assign({}, this.currentWindowState), { visible: visible }));
    };
    PageViewLogger.prototype.handleFocusStateChange = function (newState) {
        if (!this.currentWindowState)
            return;
        if (this.currentWindowState === newState) {
            return;
        }
        var wasForeground = this.isForeground(this.currentWindowState);
        var isForeground = this.isForeground(newState);
        if (!wasForeground && isForeground) {
            this.logClientGainedFocus();
        }
        else if (wasForeground && !isForeground) {
            this.logClientLostFocus();
        }
        this.currentWindowState = newState;
    };
    PageViewLogger.prototype.startNavigation = function (navigationInfo) {
        var navigationalRoot = navigationInfo.navigationalRoot;
        if (isNavigationByInteraction(navigationInfo)) {
            var interactionId = navigationInfo.interactionId;
            this.setPendingInteractionId(interactionId);
        }
        if (isNavigationByReason(navigationInfo)) {
            var navigationReason = navigationInfo.navigationReason;
            this.setPendingNavigationReason(navigationReason);
        }
        this.setPendingNavigationalRoot(navigationalRoot);
        this.setNavigationStatus(NavigationStatus.NAVIGATION_STARTED);
    };
    PageViewLogger.prototype.completeNavigation = function (navigationInfo) {
        var _a;
        var pageId = navigationInfo.pageId, entityUri = navigationInfo.entityUri;
        var isSamePageView = this.getCurrentPageId() === pageId &&
            this.getCurrentEntityUri() === entityUri &&
            this.getCurrentNavigationalRoot() === this.getPendingNavigationalRoot();
        if (this.getNavigationStatus() === NavigationStatus.NAVIGATION_STARTED &&
            !isSamePageView) {
            var pageInstanceId = this.generatePageInstanceId();
            var baseEventData = {
                page_instance_id: pageInstanceId,
                page_id: pageId,
                entity_uri: entityUri,
                navigational_root: this.getPendingNavigationalRoot(),
                from_page_instance_id: this.getCurrentPageInstanceId(),
                from_page_id: this.getCurrentPageId(),
                from_entity_uri: this.getCurrentEntityUri(),
                from_navigational_root: this.getCurrentNavigationalRoot(),
                navigation_reason: this.populateNavigationReason()
            };
            if (this.authenticationProvider.isAuthenticated()) {
                var event_1 = createUbiExpr2PageView(baseEventData);
                this.eventSender.send(event_1);
            }
            else {
                var nonAuthPageViewEventData = __assign(__assign({}, baseEventData), { flow_id: ((_a = this.flowIdProvider) === null || _a === void 0 ? void 0 : _a.getFlowId()) || null });
                var event_2 = createUbiProd1PageTransitionNonAuth(nonAuthPageViewEventData);
                this.eventSender.send(event_2);
            }
            this.setCurrent(pageId, pageInstanceId, entityUri, this.getPendingNavigationalRoot());
        }
        else {
            this.resetNavStartInfo();
        }
        this.setNavigationStatus(NavigationStatus.NAVIGATION_IDLE);
    };
    PageViewLogger.prototype.logClientLostFocus = function () {
        var _a;
        var pageInstanceId = this.generatePageInstanceId();
        var baseEventData = {
            page_instance_id: pageInstanceId,
            page_id: null,
            entity_uri: null,
            navigational_root: null,
            from_page_instance_id: this.getCurrentPageInstanceId(),
            from_page_id: this.getCurrentPageId(),
            from_entity_uri: this.getCurrentEntityUri(),
            from_navigational_root: this.getCurrentNavigationalRoot(),
            navigation_reason: NavigationReason.CLIENT_LOST_FOCUS
        };
        if (this.authenticationProvider.isAuthenticated()) {
            var event_3 = createUbiExpr2PageView(baseEventData);
            this.eventSender.send(event_3);
        }
        else {
            var nonAuthPageViewEventData = __assign(__assign({}, baseEventData), { flow_id: ((_a = this.flowIdProvider) === null || _a === void 0 ? void 0 : _a.getFlowId()) || null });
            var event_4 = createUbiProd1PageTransitionNonAuth(nonAuthPageViewEventData);
            this.eventSender.send(event_4);
        }
        this.setCurrent(this.getCurrentPageId(), pageInstanceId, this.getCurrentEntityUri(), this.getCurrentNavigationalRoot());
    };
    PageViewLogger.prototype.logClientGainedFocus = function () {
        var _a;
        var pageInstanceId = this.generatePageInstanceId();
        var baseEventData = {
            page_instance_id: pageInstanceId,
            page_id: this.getCurrentPageId(),
            entity_uri: this.getCurrentEntityUri(),
            navigational_root: this.getCurrentNavigationalRoot(),
            from_page_instance_id: this.getCurrentPageInstanceId(),
            from_page_id: null,
            from_entity_uri: null,
            from_navigational_root: null,
            navigation_reason: NavigationReason.CLIENT_GAINED_FOCUS
        };
        if (this.authenticationProvider.isAuthenticated()) {
            var event_5 = createUbiExpr2PageView(baseEventData);
            this.eventSender.send(event_5);
        }
        else {
            var nonAuthPageViewEventData = __assign(__assign({}, baseEventData), { flow_id: ((_a = this.flowIdProvider) === null || _a === void 0 ? void 0 : _a.getFlowId()) || null });
            var event_6 = createUbiProd1PageTransitionNonAuth(nonAuthPageViewEventData);
            this.eventSender.send(event_6);
        }
        this.setCurrent(this.getCurrentPageId(), pageInstanceId, this.getCurrentEntityUri(), this.getCurrentNavigationalRoot());
    };
    PageViewLogger.prototype.addEventListeners = function () {
        if (this.disableAutoBackgroundMonitoring)
            return;
        if (!window)
            return;
        if (!document)
            return;
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        window.addEventListener('blur', this.onBlur);
        window.addEventListener('focus', this.onFocus);
    };
    PageViewLogger.prototype.removeEventListeners = function () {
        if (this.disableAutoBackgroundMonitoring)
            return;
        if (!window)
            return;
        if (!document)
            return;
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        window.removeEventListener('blur', this.onBlur);
        window.removeEventListener('focus', this.onFocus);
    };
    return PageViewLogger;
}());
export { PageViewLogger };
//# sourceMappingURL=PageViewLogger.js.map